import React from "react";
import "./LimitedByDesign.css";

const LimitedByDesign = () => {
  return (
    <section className="limited-by-design">
      <div className="limited-by-design__inner">
        <h2>LIMITED BY DESIGN</h2>

        <p>
          We don't believe every beautiful thing needs to be made endlessly.
          Our styles are produced in limited quantities, and once they're gone,
          we may not restock them.
        </p>

        <strong>So your STILL pair might be one of very few.</strong>
      </div>
    </section>
  );
};

export default LimitedByDesign;
